/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unnecessary-type-assertion */
import type {ReactNode} from 'react';

type FieldGroupProps = {
	title: string;
	children: ReactNode;
};

const FieldSetSumma = ({title, children}: FieldGroupProps) => (
	<div className="border rounded p-3 position-relative mt-4 px-4">
		<span className="position-absolute fw-semibold text-bg-light field-set-summa">
			{title}
		</span>
		{children}
	</div>
);

export default FieldSetSumma;
